module.exports = __webpack_public_path__ + "img/KZ.31d9dfa3.png";